import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AnimatedBlueButton } from "src/components/common";
import { useClipPathOnScroll } from "src/hooks/useClipPathOnScroll";

export const WeDo: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { ref, clipPath } = useClipPathOnScroll();
  const { ref: ref2, clipPath: clipPath2 } = useClipPathOnScroll();

  return (
    <Box
      id="service"
      sx={{
        paddingBlock: "86px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "white",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1920px",
          paddingInline: "clamp(16px,4.167vw,80px)",
          display: "grid",
          gridTemplateColumns: "repeat(12,1fr)",
          columnGap: "clamp(10px,.833vw,16px)",
          rowGap: "24px",
          position: "relative",
          zIndex: 1,
          color: "#000000",
          [theme.breakpoints.down("md")]: { display: "flex", gap: "32px", flexDirection: "column", paddingInline: "72px" },
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridArea: "1/1/1/10",
            gridTemplateColumns: "repeat(9,1fr)",
            gap: "12px",
            [theme.breakpoints.down("md")]: { display: "flex" },
          }}
        >
          <Typography
            sx={{ fontSize: "3.125vw", lineHeight: 1.1, color: "#6985b41f", [theme.breakpoints.down("md")]: { display: "none" } }}
          >
            02
          </Typography>
          <Typography sx={{ fontSize: "clamp(28px,3.125vw,60px)", fontWeight: 500, lineHeight: 1.1, color: "#000000", gridColumn: "2/-1" }}>
            {t("home.we_do.title")}
          </Typography>
        </Box>
        <Box
          ref={ref}
          sx={{
            clipPath: clipPath,
            width: "100%",
            height: "auto",
            display: "flex",
            gridArea: "2/6/2/11",
            borderRadius: "12px",
            aspectRatio: "724/483",
            overflow: "hidden",
            img: {
              width: "100%",
              height: "100%",
              objectFit: "cover",
            },
          }}
        >
          <img src={require("src/assets/images/home/thisisengineering-uyfohHiTxho-unsplash.jpg")} alt="" />
        </Box>
        <Box data-aos="fade-up" sx={{ display: "flex", flexDirection: "column", gridArea: "2/2/5/5" }}>
          <Typography sx={{ fontSize: "clamp(16px,1vw,18px)", fontWeight: "500", lineHeight: 1.6, mb: "5px" }}>
            {t("home.we_do.title1")}
          </Typography>
          <Typography sx={{ fontSize: "clamp(14px,.833vw,16px)", fontWeight: "400", lineHeight: 1.6 }}>
            {t("home.we_do.description1")}
          </Typography>
          <Box sx={{ marginBlock: "clamp(32px,2.083vw,40px) clamp(32px,3.125vw,60px)" }}>
            <AnimatedBlueButton text={t("home.we_do.button")} />
          </Box>
          <Box
            ref={ref2}
            sx={{
              clipPath: clipPath2,
              borderRadius: "clamp(8px,.625vw,12px)",
              maxWidth: "clamp(300px,17.604vw,338px)",
              aspectRatio: 1,
              width: "100%",
              display: "flex",
              overflow: "hidden",
              img: { objectFit: "cover", width: "100%", height: "100%" },
            }}
          >
            <img src={require("src/assets/images/home/galina-nelyubova-Utist2Ru8Rc-unsplash.jpg")} alt="cloud" width={300} height={300} />
          </Box>
        </Box>
        <Box data-aos="fade-up" sx={{ display: "flex", flexDirection: "column", gridArea: "3/6/5/10" }}>
          <Typography sx={{ fontSize: "clamp(16px,1vw,18px)", fontWeight: "500", lineHeight: 1.6, mb: "5px" }}>
            {t("home.we_do.title2")}
          </Typography>
          <Typography sx={{ fontSize: "clamp(14px,.833vw,16px)", fontWeight: "400", lineHeight: 1.6 }}>
            {t("home.we_do.description2")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
export default WeDo;
